<template>
  <div class="report" v-cloak>
    <div class="investor-nav">
      <div class="investor-nav-item">Announcement</div>
    </div>
    <InvestorReport :cat="8000005"/>
  </div>
</template>
<script>
  import InvestorReport from "./InvestorReport";

/**
 * 重要公告
 */
export default {
  name: 'ImportantAnnouncement',
  components: {
    InvestorReport
  }
}
</script>
<style scoped>
  .investor-nav {
    padding: .6rem 5vw;
    background: #fff;
    box-shadow: 0 0 1rem rgba(0,0,0,0.1);
  }
  .investor-nav-item {
    border-left: 5px solid #ff7800;
    padding-left: .5rem;
    font-weight: 600;
  }
  .report {
    font-size: 1rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/en/investor/ImportantAnnouncement.vue